export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'
export const IS_LOGGED = 'IS_LOGGED'
export const ISNT_LOGGED = 'ISNT_LOGGED'
